import SectionLabel from "@/components/base/SectionLabel";
import { processData } from "@/mocks/homeData";

export default function ProcessSection() {
  return (
    <section id="process" className="py-16 md:py-24 bg-background-50">
      <div className="max-w-[1200px] mx-auto px-4 md:px-8">
        <div className="text-center mb-12 md:mb-16 reveal">
          <SectionLabel label={processData.label} className="mb-3" />
          <h2 className="font-heading text-2xl md:text-3xl lg:text-4xl font-bold text-foreground-900">
            {processData.title}
          </h2>
        </div>

        {/* Desktop: horizontal timeline */}
        <div className="hidden lg:block">
          <div className="relative">
            {/* Connector line */}
            <div className="absolute top-[28px] left-[16%] right-[16%] h-px bg-background-300" />
            <div className="flex justify-between gap-6">
              {processData.steps.map((step, idx) => (
                <div
                  key={step.num}
                  className="reveal relative flex flex-col items-center text-center"
                  style={{ width: "28%", transitionDelay: `${idx * 400}ms` }}
                >
                  <div className="relative z-10 w-14 h-14 rounded-full bg-primary-500 text-background-50 flex items-center justify-center text-base font-bold font-heading mb-5 shadow-sm">
                    {step.num}
                  </div>
                  <h3 className="text-base font-bold text-foreground-900 mb-2 font-heading">
                    {step.title}
                  </h3>
                  <p className="text-sm text-foreground-700 leading-relaxed">
                    {step.desc}
                  </p>
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* Mobile/Tablet: vertical list */}
        <div className="lg:hidden space-y-6 md:space-y-8">
          {processData.steps.map((step, idx) => (
            <div
              key={step.num}
              className="reveal flex gap-4 md:gap-5 items-start"
              style={{ transitionDelay: `${idx * 350}ms` }}
            >
              <div className="flex flex-col items-center">
                <div className="w-10 h-10 md:w-12 md:h-12 rounded-full bg-primary-500 text-background-50 flex items-center justify-center text-sm md:text-base font-bold font-heading flex-shrink-0">
                  {step.num}
                </div>
                {idx < processData.steps.length - 1 && (
                  <div className="w-px flex-1 min-h-[40px] bg-background-300 mt-2" />
                )}
              </div>
              <div className="pt-1 md:pt-2">
                <h3 className="text-base md:text-lg font-bold text-foreground-900 mb-1.5 md:mb-2 font-heading">
                  {step.title}
                </h3>
                <p className="text-sm md:text-base text-foreground-700 leading-relaxed">
                  {step.desc}
                </p>
              </div>
            </div>
          ))}
        </div>

        <div className="text-center mt-10 md:mt-12 reveal">
          <a
            href="/process"
            className="inline-flex items-center gap-1.5 text-sm md:text-base font-medium text-primary-600 hover:text-primary-700 transition-colors cursor-pointer"
          >
            詳細な流れを見る
            <i className="ri-arrow-right-line" />
          </a>
        </div>
      </div>
    </section>
  );
}